'use strict';

import React from 'react';

import Button from "react-bootstrap/Button"

import {useAppContext} from "@uw-it-sis/lib-react/lib/AppContext";
import Backdoor from "@uw-it-sis/lib-react/lib/Backdoor";
import AppInfo from "@uw-it-sis/lib-react/lib/AppInfo";
import NowTime from "@uw-it-sis/lib-react/lib/NowTime";
import RegTools from "@uw-it-sis/lib-react/lib/RegTools";

import {MetricKeys, MetricLabels} from './Constants';

/**
 * The footer component.
 */
const Footer = (props) => {
    const appStore = useAppContext().appStore;
    const analyticsStore = appStore.getAnalyticsStore();

    const logEvent = (context) => {
        // For nav events, dest is usually created by OrgUtils.getPageFromUrl(href), but since
        // footer links are to outside of myplan, we'll just log the context.
        // FIXME: See what the actual value of this one is
        const labels = analyticsStore.label(MetricLabels.navLinkDestName, context).add(MetricLabels.navType, "footer").get();
        analyticsStore.addEvent(MetricKeys.navigation, labels, {context: context});
    };

    let devTools = [];

    if ( appStore.isDevMode() || appStore.isBackdoorAllowed() ) {
        if ( appStore.isAuthenticated() && appStore.isBackdoorAllowed() ) {
            devTools.push(<Backdoor key="backdoor" openComponent={Button} />);
        }

        devTools.push(<NowTime key="nowtime" openComponent={Button} />);
        devTools.push(<RegTools key="regtools" openComponent={Button} />);
    }

    return (
        <footer className="d-print-none d-grid gap-3 p-3 text-center fs-7 bg-navigate border border-3 border-start-0 border-end-0 border-bottom-0" role="contentinfo">
            <ul className="list-inline list-inline-pipe-separated m-0">
                <li className="list-inline-item"><a href="https://itconnect.uw.edu/learn/tools/myplan-academic-planner/" onClick={() => logEvent("itconnect-myplan-help")} target="_blank">MyPlan Help</a></li>
                <li className="list-inline-item"><a href="https://itconnect.uw.edu/help/" onClick={() => logEvent("itconnect-contact")} target="_blank">Contact</a></li>
                <li className="list-inline-item"><a href="http://www.washington.edu/online/terms" target="_blank">Terms</a></li>
                <li className="list-inline-item"><a href="http://www.washington.edu/online/privacy" target="_blank">Privacy</a></li>
            </ul>
            <div>&copy; {new Date().getFullYear()} University of Washington</div>
            <ul className="list-inline list-inline-pipe-separated m-0">
                <li className="list-inline-item" key="info"><AppInfo /></li>
                {devTools.map((component, i) => (
                    <li className="list-inline-item" key={i}>
                        {component}
                    </li>
                ))}
            </ul>
        </footer>
    );
};

export default Footer;